import * as React from 'react';
import { connect } from 'react-redux';
import { Card, CardBody } from 'reactstrap';
import { Privilege } from '../../clients/aasServerClient.generated';
import { getAssignablePrivileges } from '../../stores/auth/selectors';
import { RootState } from '../../stores/store';
import FormInput from '../common/FormInput';

interface Props {
    privileges: Privilege[];
    updateSelection: (selection: Array<{ id: string, value: boolean }>) => void;

    assignable: Array<{ name: string }>;
}

interface State {
    selection: Array<{ id: string, value: boolean }>;
}

class PrivilegeSelector extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);
        this.state = {
            selection: this.props.assignable.map((p) => ({
                id: p.name,
                value: this.props.privileges!.find((x) => x.name === p.name) !== undefined,
            }))
        };
        this.props.updateSelection(this.state.selection);
    }

    public render() {
        let superAdminIndex = -1;
        let privileges: React.ReactNode[] = [];
        this.state.selection.some((p, index) => {
            if (p.id === 'SUPER_ADMIN') {
                superAdminIndex = index;
                return true;
            }
            return false;
        });
        if (superAdminIndex >= 0) {
            privileges.push(
                <div key={-1} >
                    <FormInput
                        name="SUPER_ADMIN"
                        type="checkbox"
                        fullName="SUPER_ADMIN"
                        checked={this.state.selection[superAdminIndex].value}
                        onChange={() => this.select(superAdminIndex)}
                    />
                    <hr />
                </div>
            );
        }
        privileges = privileges.concat(this.props.assignable.map((p, i) =>
            p.name !== 'SUPER_ADMIN'
                ? (
                    <div key={i} >
                        <FormInput
                            name={p.name}
                            type="checkbox"
                            fullName={p.name}
                            checked={this.state.selection[i].value}
                            onChange={() => this.select(i)}
                        />
                    </div>
                )
                : ''
        ));
        return (
            <Card>
                <CardBody>
                    {privileges}
                </CardBody>
            </Card>
        );
    }

    private select = (index: number) => {
        const newSelection = [...this.state.selection];
        newSelection[index].value = !newSelection[index].value;
        this.setState({ selection: newSelection });
        this.props.updateSelection(newSelection);
    }
}

const mapStateToProps = (state: RootState) => ({
    assignable: getAssignablePrivileges(state),
});

export default connect(mapStateToProps)(PrivilegeSelector);